import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const checkIconVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type CheckIconProps = IconProps &
  React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof checkIconVariants>;

const CheckIcon = React.forwardRef<SVGSVGElement, CheckIconProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          checkIconVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 16 16'}
        width={width}
        {...props}
      >
        <path d="M5.66667 11.0573L3.138 8.52865C3.01227 8.40721 2.84387 8.34002 2.66907 8.34154C2.49427 8.34306 2.32706 8.41317 2.20346 8.53677C2.07985 8.66038 2.00974 8.82759 2.00822 9.00239C2.0067 9.17718 2.0739 9.34558 2.19534 9.47132L5.19534 12.4713C5.32035 12.5963 5.48989 12.6665 5.66667 12.6665C5.84344 12.6665 6.01298 12.5963 6.138 12.4713L13.4713 5.13799C13.5928 5.01225 13.66 4.84385 13.6585 4.66905C13.6569 4.49425 13.5868 4.32705 13.4632 4.20344C13.3396 4.07984 13.1724 4.00972 12.9976 4.0082C12.8228 4.00668 12.6544 4.07388 12.5287 4.19532L5.66667 11.0573Z" />
      </svg>
    );
  },
);

CheckIcon.displayName = 'CheckIcon';

export { CheckIcon, checkIconVariants };
